import * as React from "react";
import PropTypes from "prop-types";
import {
  IconBatteryEmpty,
  IconBatteryMostlyFull,
  IconBatteryFull,
  IconBatteryLow,
} from "nx-components/Icons";

const MinimalBatteryIndicator = ({ icon, level, style }) => {
  let iconName;
  let modifiers = [];
  if (icon) {
    [iconName, ...modifiers] = icon.split(" ");
  }

  let iconStyle = {
    verticalAlign: "bottom",
    ...style,
  };
  if (iconName === "battery_full" || level > 75) {
    return <IconBatteryFull style={iconStyle} modifiers={modifiers} />;
  } else if (iconName === "battery_mostly_full" || level > 30) {
    return <IconBatteryMostlyFull style={iconStyle} modifiers={modifiers} />;
  } else if (iconName === "battery_mostly_empty" || level > 1) {
    modifiers.push("alert");
    return <IconBatteryLow style={iconStyle} modifiers={modifiers} />;
  }
  return <IconBatteryEmpty style={iconStyle} modifiers={modifiers} />;
};
MinimalBatteryIndicator.propTypes = {
  icon: PropTypes.string.isRequired,
  level: PropTypes.number,
  style: PropTypes.object,
};

export default MinimalBatteryIndicator;



// WEBPACK FOOTER //
// ./src/components/MinimalBatteryIndicator.jsx